// Module
var code = "{{ isUisEnabled ? 'TM Authentication Settings' : 'Reset User Credentials' }} <i class=\"fa fa-info-circle icon-md after-heading\" popover-placement=\"right\" popover-trigger=\"mouseenter\" popover-append-to-body=\"true\" data-popover=\"{{popOverText}}\" aria-hidden=\"true\"></i> ";
// Exports
module.exports = code;